import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';
import {cssProperties} from '../../../css/cssProperties';
import {getProductData} from '../../../util/getProductData';
import {getValueOfFeature, isSatisfied, pimText, pimTextDebug} from '../../../util/values';

@customElement('visual-lightprofile-summary-lamps-height')
export class VisualLightprofileSummaryLampsHeight extends connect(store)(LitElement) {

	static styles = [
		css`
		.lampsHeight {
			padding: 100px var(--large-padding);
		}

		.heightDiagram {
			display: grid;
			gap: 0px 0px;
			grid-auto-flow: row dense;
			grid-template-columns: 4fr 8fr;
			padding: 100px 140px 100px 0px;
		}

		.description {
			color: var(--color-grey4);
			font: var(--font-summary-paragraph);
			line-height: 22px;
			max-width: 70%;
			text-align: left;
		}

		.description h5 {
			color: var(--color-white);
			letter-spacing: 0.2;
		}
		.diagram {
			margin-left: 7%;
		}

		.diagram svg {
			max-width: 100%;
		}

		.heightDiagramChoice  {
			fill: #ECECEC;
		}

		.colorContainer:hover {
			background-color: #C6C6C6;
		}
		@media (max-width: 768px) {

			.lampsSection {
				display: block;
				padding: 50px 0;
			}

			.lampsHeight {
				padding: var(--large-padding) var(--small-padding);
			}

			.description {
				max-width: 100%;
			}

			.heightDiagram {
				display: block;
				padding: 0px 0px;
			}

			.diagram {
				padding-top: 50px;
				margin-left: 0px;
			}

			.diagram svg {
				margin-left: 0px;
			}

		 }

		`
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.state = state;
		this.translations = state.productData.translations;
		this.decisions = state.decisions.data;
		this.profile = state.lightProfile.data.profile;
		this.lightProfile = state.lightProfile.data;
		this.productData = state.productData.productData;
		this.lang = state.status.lang;

	}
	getValueFromProductData(featureId, featureValueId) {
		const pd = getProductData(featureId, this.productData);
		return pd?.values?.find(val => val.valueId === featureValueId);
	}

	render() {
		const s = this.state;

		return html`
	<section class="lampsHeight">


			<div class="heightDiagram">
				<div class="description">
					<h5>Masthöhen</h5>
			  	</div>

			  	<div class="diagram">
				  <svg width="818" height="290" viewBox="0 0 818 290" fill="none" xmlns="http://www.w3.org/2000/svg">
				 	 <line x1="1" y1="289.5" x2="818" y2="289.5" stroke="#313131"/>
				 	 <line x1="1" y1="231.5" x2="30" y2="231.5" stroke="#313131"/>
				 	 <line x1="1" y1="260.5" x2="30" y2="260.5" stroke="#313131"/>
				 	 <line x1="1" y1="202.5" x2="30" y2="202.5" stroke="#313131"/>
				 	 <line x1="1" y1="173.5" x2="30" y2="173.5" stroke="#313131"/>
				 	 <line x1="1" y1="144.5" x2="30" y2="144.5" stroke="#313131"/>
				 	 <line x1="1" y1="115.5" x2="30" y2="115.5" stroke="#313131"/>
				 	 <line x1="1" y1="86.5" x2="30" y2="86.5" stroke="#313131"/>
				 	 <line x1="1" y1="86.5" x2="30" y2="86.5" stroke="#313131"/>
				 	 <line x1="0.5" y1="290" x2="0.499987" y2="2.18557e-08" stroke="#313131" />
				 	 <path class="three heightDiagramChoice" d="M212.635 188.35C213.25 189.52 214.51 190.15 215.95 190.15C217.9 190.15 219.535 188.62 219.535 186.55C219.535 184.795 218.29 183.37 216.7 183.13L219.01 180.475V179.5H213.16V180.925H216.79L214.555 183.565V184.54C214.72 184.495 215.185 184.375 215.77 184.375C217.09 184.375 218.035 185.29 218.035 186.55C218.035 187.81 217.045 188.725 215.86 188.725C214.99 188.725 214.225 188.29 213.88 187.63L212.635 188.35ZM221.835 182.95V190H223.26V185.155C223.665 184.675 224.37 184.15 225.24 184.15C225.78 184.15 226.29 184.39 226.605 184.765C226.86 185.065 227.01 185.455 227.01 186.175V190H228.435V186.4C228.435 185.905 228.39 185.5 228.315 185.155C228.78 184.675 229.44 184.15 230.46 184.15C230.985 184.15 231.465 184.39 231.78 184.765C232.035 185.065 232.185 185.455 232.185 186.175V190H233.61V186.4C233.61 185.215 233.4 184.525 232.965 183.985C232.38 183.25 231.465 182.8 230.46 182.8C229.185 182.8 228.42 183.325 227.775 183.97C227.19 183.265 226.32 182.8 225.285 182.8C224.325 182.8 223.5 183.31 223.215 183.625V182.95H221.835Z" fill="white"/>
				 	 <rect class="three heightDiagramChoice"  x="221.5" y="206" width="4" height="84" fill="#313131"/>
				 	 <path class="four" d="M305.294 160.45H310.244V163H311.744V160.45H313.394V159.025H311.744V152.5H310.694L305.294 159.475V160.45ZM307.424 159.025L310.244 155.485V159.025H307.424ZM315.026 155.95V163H316.451V158.155C316.856 157.675 317.561 157.15 318.431 157.15C318.971 157.15 319.481 157.39 319.796 157.765C320.051 158.065 320.201 158.455 320.201 159.175V163H321.626V159.4C321.626 158.905 321.581 158.5 321.506 158.155C321.971 157.675 322.631 157.15 323.651 157.15C324.176 157.15 324.656 157.39 324.971 157.765C325.226 158.065 325.376 158.455 325.376 159.175V163H326.801V159.4C326.801 158.215 326.591 157.525 326.156 156.985C325.571 156.25 324.656 155.8 323.651 155.8C322.376 155.8 321.611 156.325 320.966 156.97C320.381 156.265 319.511 155.8 318.476 155.8C317.516 155.8 316.691 156.31 316.406 156.625V155.95H315.026Z" fill="#313131"/>
				 	 <rect class="four" x="314.5" y="179" width="4" height="111" fill="#313131"/>
				 	 <path class="five" d="M404.877 124.925V123.5H399.957L399.207 128.825L400.242 128.975C400.632 128.615 401.202 128.375 401.832 128.375C403.122 128.375 403.962 129.365 403.962 130.55C403.962 131.735 403.137 132.725 401.877 132.725C401.037 132.725 400.332 132.29 399.927 131.765L398.787 132.65C399.432 133.565 400.572 134.15 401.862 134.15C403.932 134.15 405.462 132.515 405.462 130.55C405.462 128.585 403.932 126.95 401.877 126.95C401.532 126.95 401.202 127.025 400.887 127.13L401.187 124.925H404.877ZM407.909 126.95V134H409.334V129.155C409.739 128.675 410.444 128.15 411.314 128.15C411.854 128.15 412.364 128.39 412.679 128.765C412.934 129.065 413.084 129.455 413.084 130.175V134H414.509V130.4C414.509 129.905 414.464 129.5 414.389 129.155C414.854 128.675 415.514 128.15 416.534 128.15C417.059 128.15 417.539 128.39 417.854 128.765C418.109 129.065 418.259 129.455 418.259 130.175V134H419.684V130.4C419.684 129.215 419.474 128.525 419.039 127.985C418.454 127.25 417.539 126.8 416.534 126.8C415.259 126.8 414.494 127.325 413.849 127.97C413.264 127.265 412.394 126.8 411.359 126.8C410.399 126.8 409.574 127.31 409.289 127.625V126.95H407.909Z" fill="#313131"/>
				 	 <rect class="five" x="407.5" y="150" width="4" height="140" fill="#313131"/>
				 	 <path class="six" d="M494.258 92.93C494.633 92.57 495.233 92.375 495.908 92.375C497.138 92.375 498.023 93.395 498.023 94.58C498.023 95.75 497.138 96.725 495.878 96.725C494.663 96.725 493.733 95.795 493.733 94.55C493.733 93.95 493.898 93.485 494.258 92.93ZM497.768 87.5H496.073L493.583 91.28C493.163 91.91 492.803 92.51 492.593 92.99C492.323 93.605 492.248 94.1 492.248 94.595C492.248 96.56 493.763 98.15 495.878 98.15C497.978 98.15 499.523 96.56 499.523 94.55C499.523 92.525 497.963 90.995 496.043 90.995C495.863 90.995 495.668 90.995 495.473 91.025L497.768 87.5ZM501.672 90.95V98H503.097V93.155C503.502 92.675 504.207 92.15 505.077 92.15C505.617 92.15 506.127 92.39 506.442 92.765C506.697 93.065 506.847 93.455 506.847 94.175V98H508.272V94.4C508.272 93.905 508.227 93.5 508.152 93.155C508.617 92.675 509.277 92.15 510.297 92.15C510.822 92.15 511.302 92.39 511.617 92.765C511.872 93.065 512.022 93.455 512.022 94.175V98H513.447V94.4C513.447 93.215 513.237 92.525 512.802 91.985C512.217 91.25 511.302 90.8 510.297 90.8C509.022 90.8 508.257 91.325 507.612 91.97C507.027 91.265 506.157 90.8 505.122 90.8C504.162 90.8 503.337 91.31 503.052 91.625V90.95H501.672Z" fill="#313131"/>
				 	 <rect class="six" x="501" y="114" width="4" height="176" fill="#313131"/>
				 	 <path class="seven" d="M587.994 71L592.689 61.475V60.5H586.089V61.925H590.889L586.389 71H587.994ZM594.682 63.95V71H596.107V66.155C596.512 65.675 597.217 65.15 598.087 65.15C598.627 65.15 599.137 65.39 599.452 65.765C599.707 66.065 599.857 66.455 599.857 67.175V71H601.282V67.4C601.282 66.905 601.237 66.5 601.162 66.155C601.627 65.675 602.287 65.15 603.307 65.15C603.832 65.15 604.312 65.39 604.627 65.765C604.882 66.065 605.032 66.455 605.032 67.175V71H606.457V67.4C606.457 66.215 606.247 65.525 605.812 64.985C605.227 64.25 604.312 63.8 603.307 63.8C602.032 63.8 601.267 64.325 600.622 64.97C600.037 64.265 599.167 63.8 598.132 63.8C597.172 63.8 596.347 64.31 596.062 64.625V63.95H594.682Z" fill="#313131"/>
				 	 <rect class="seven" x="594.5" y="87" width="4" height="203" fill="#313131"/>
				  </svg>
			  	</div>
			</div>


	  </section>


		`;
	}
}
